import React, { useState, useEffect } from 'react';
import '../../styles/CookieConsent.css';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [preferences, setPreferences] = useState({
        necessary: true, // Always true, cannot be disabled
        analytics: false,
        marketing: false,
        functional: false
    });

    useEffect(() => {
        const consent = localStorage.getItem('ferritico-cookie-consent');
        if (!consent) {
            setIsVisible(true);
        } else {
            const savedPreferences = JSON.parse(consent);
            setPreferences(savedPreferences);
            applyCookieSettings(savedPreferences);
        }
    }, []);

    const applyCookieSettings = (prefs) => {
        // Apply analytics cookies
        if (prefs.analytics) {
            // Enable Google Analytics or other analytics
            console.log('Analytics cookies enabled');
        } else {
            // Disable analytics
            console.log('Analytics cookies disabled');
        }

        // Apply marketing cookies
        if (prefs.marketing) {
            console.log('Marketing cookies enabled');
        } else {
            console.log('Marketing cookies disabled');
        }

        // Apply functional cookies
        if (prefs.functional) {
            console.log('Functional cookies enabled');
        } else {
            console.log('Functional cookies disabled');
        }
    };

    const handleAcceptAll = () => {
        const allAccepted = {
            necessary: true,
            analytics: true,
            marketing: true,
            functional: true
        };
        setPreferences(allAccepted);
        localStorage.setItem('ferritico-cookie-consent', JSON.stringify(allAccepted));
        applyCookieSettings(allAccepted);
        setIsVisible(false);
    };

    const handleAcceptSelected = () => {
        localStorage.setItem('ferritico-cookie-consent', JSON.stringify(preferences));
        applyCookieSettings(preferences);
        setIsVisible(false);
    };

    const handleDeclineAll = () => {
        const onlyNecessary = {
            necessary: true,
            analytics: false,
            marketing: false,
            functional: false
        };
        setPreferences(onlyNecessary);
        localStorage.setItem('ferritico-cookie-consent', JSON.stringify(onlyNecessary));
        applyCookieSettings(onlyNecessary);
        setIsVisible(false);
    };

    const handlePreferenceChange = (type) => {
        if (type === 'necessary') return; // Cannot change necessary cookies
        setPreferences(prev => ({
            ...prev,
            [type]: !prev[type]
        }));
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-consent-overlay">
            <div className="cookie-consent-banner">
                <div className="cookie-content">
                    <div className="cookie-header">
                        <h3>🍪 We Use Cookies</h3>
                        <p>
                            This website uses cookies to provide you with the best user experience. 
                            Some are necessary for functionality, others help us improve our website 
                            and show you relevant content.
                        </p>
                    </div>

                    {!showDetails ? (
                        <div className="cookie-actions">
                            <button 
                                className="cookie-btn cookie-btn-primary"
                                onClick={handleAcceptAll}
                            >
                                Accept All
                            </button>
                            <button 
                                className="cookie-btn cookie-btn-secondary"
                                onClick={() => setShowDetails(true)}
                            >
                                Settings
                            </button>
                            <button 
                                className="cookie-btn cookie-btn-decline"
                                onClick={handleDeclineAll}
                            >
                                Essential Only
                            </button>
                        </div>
                    ) : (
                        <div className="cookie-details">
                            <div className="cookie-categories">
                                <div className="cookie-category">
                                    <div className="category-header">
                                        <label className="cookie-toggle">
                                            <input
                                                type="checkbox"
                                                checked={preferences.necessary}
                                                disabled={true}
                                                readOnly
                                            />
                                            <span className="toggle-slider disabled"></span>
                                            <span className="category-name">Essential Cookies</span>
                                        </label>
                                    </div>
                                    <p className="category-description">
                                        These cookies are essential for the website's basic functionality 
                                        and cannot be disabled.
                                    </p>
                                </div>

                                <div className="cookie-category">
                                    <div className="category-header">
                                        <label className="cookie-toggle">
                                            <input
                                                type="checkbox"
                                                checked={preferences.analytics}
                                                onChange={() => handlePreferenceChange('analytics')}
                                            />
                                            <span className="toggle-slider"></span>
                                            <span className="category-name">Analytics Cookies</span>
                                        </label>
                                    </div>
                                    <p className="category-description">
                                        Help us understand how visitors interact with the website 
                                        by collecting and reporting information anonymously.
                                    </p>
                                </div>

                                <div className="cookie-category">
                                    <div className="category-header">
                                        <label className="cookie-toggle">
                                            <input
                                                type="checkbox"
                                                checked={preferences.marketing}
                                                onChange={() => handlePreferenceChange('marketing')}
                                            />
                                            <span className="toggle-slider"></span>
                                            <span className="category-name">Marketing Cookies</span>
                                        </label>
                                    </div>
                                    <p className="category-description">
                                        Used to track visitors across websites and display 
                                        personalized advertisements.
                                    </p>
                                </div>

                                <div className="cookie-category">
                                    <div className="category-header">
                                        <label className="cookie-toggle">
                                            <input
                                                type="checkbox"
                                                checked={preferences.functional}
                                                onChange={() => handlePreferenceChange('functional')}
                                            />
                                            <span className="toggle-slider"></span>
                                            <span className="category-name">Functional Cookies</span>
                                        </label>
                                    </div>
                                    <p className="category-description">
                                        Enable enhanced functionality and personalization 
                                        such as videos and live chat.
                                    </p>
                                </div>
                            </div>

                            <div className="cookie-actions">
                                <button 
                                    className="cookie-btn cookie-btn-primary"
                                    onClick={handleAcceptSelected}
                                >
                                    Save Preferences
                                </button>
                                <button 
                                    className="cookie-btn cookie-btn-secondary"
                                    onClick={() => setShowDetails(false)}
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="cookie-links">
                        <a href="/privacy-policy" className="cookie-link">Privacy Policy</a>
                        <a href="/legal" className="cookie-link">Legal Notice</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;